import { render, staticRenderFns } from "./Vselect.vue?vue&type=template&id=18338a00"
import script from "./Vselect.vue?vue&type=script&lang=js"
export * from "./Vselect.vue?vue&type=script&lang=js"
import style0 from "./Vselect.vue?vue&type=style&index=0&id=18338a00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports